<template>
<div class="admin__productgrooupdata">
  <b-modal :id="this.modalID"
           :title="$t(this.modalTitle)"
           :ok-title="$t(this.modalOK)"
           :cancel-title="$t('Cancel')"
           @show="handleShow"
           @ok="handleOk">
    <div>
        {{$t('Are you sure you want to delete')}} {{ this.product_group.name }}?
    </div>
  </b-modal>
</div>
</template>

<script>

import { mapActions } from 'vuex'

export default {
  name: 'ProductGroupDeleteModal',
  props: {
    product_group: [Object, Boolean]
  },
  computed: {
    ID () {
      if (!this.product_group) {
        return 'delete-'
      }
      return `${this.product_group.id}-`
    },
    modalID () {
      return `delete-product_group-${this.product_group.id}`
    },
    modalTitle () {
      return `${this.$t('Delete Product Group')}: ${this.product_group.name}`
    },
    modalOK () {
      return this.$t('Delete')
    }
  },
  methods: {
    ...mapActions({
      deleteProductGroup: 'admin/deleteProductGroup',
      fetchProductGroups: 'admin/fetchProductGroups'
    }),
    handleOk (event) {
      event.preventDefault()
      this.deleteProductGroup(this.product_group.id).then(response => {
        this.handleResponse(response)
      })
    },
    handleResponse (response) {
      if (response.status === 'ok') {
        // TO-DO: Display success notification
        this.fetchProductGroups()
        this.$nextTick(() => {
          this.$bvModal.hide(this.modalID)
        })
      }
    },
    handleShow () {
      Object.assign(this.$data, this.$options.data.apply(this))
    }
  }
}
</script>

<style lang="scss">

</style>
